import { parse } from "@babel/parser";

const DEFAULT_PARSER_OPTIONS = {
  sourceType: "unambiguous",
  allowReturnOutsideFunction: true,
  plugins: [
    "classProperties",
    "classPrivateProperties",
    "classPrivateMethods",
    "dynamicImport",
    "importMeta",
    "optionalChaining",
    "nullishCoalescingOperator",
    "topLevelAwait",
    "jsx",
  ],
};

const normalizeParseError = error => {
  if (!error) return { message: "Unknown error" };
  return {
    message: error.message || "Unknown error",
    line: error.loc?.line,
    column: error.loc?.column,
  };
};

/**
 * Validates JavaScript syntax without executing the code.
 *
 * @param {string} code - The JavaScript code to validate.
 * @param {Object} [options] - Optional parser overrides for @babel/parser.
 * @returns {{ ok: boolean, error?: { message: string, line?: number, column?: number } }}
 */
export default function validateUserJs(code, options = {}) {
  try {
    parse(code || "", { ...DEFAULT_PARSER_OPTIONS, ...options });
    return { ok: true };
  } catch (error) {
    return { ok: false, error: normalizeParseError(error) };
  }
}
